"use strict";

exports.__esModule = true;
exports.AppearanceSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _helper = require("../../Widgets/MeasureChart/helper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AppearanceSelector = exports.AppearanceSelector = function AppearanceSelector(props) {
  var _appearance$areaStyle, _chartItem$appearance, _chartItem$appearance2;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var elementEditor = props.elementEditor,
    path = props.path,
    itemIndex = props.itemIndex,
    chartItem = props.chartItem,
    options = props.options;
  var appearance = chartItem == null ? void 0 : chartItem.appearance;
  (0, _react.useEffect)(function () {
    if (!appearance || Object.entries(appearance).length === 0) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].appearance",
          value: el.props.chartItems.props[itemIndex].appearance = {
            areaStyles: {
              show: false
            },
            smooth: false,
            step: false,
            showBackground: false,
            stackData: false,
            hideXAxis: false,
            hideYAxis: false,
            showGrid: !(options != null && options.hideGridOnDefault)
          }
        };
      });
    }
  }, [appearance, options, elementEditor, path, itemIndex]);
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
    "data-testid": "AppearanceSelector"
  }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("AppearanceSelector.appearance.label", "Appearance options")), (options == null ? void 0 : options.showAreaOption) && /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("AppearanceSelector.areaStylesShow.switch", "Show area"),
    "data-testid": "AppearanceSelector.areaStylesShow.switch",
    checked: appearance == null || (_appearance$areaStyle = appearance.areaStyles) == null ? void 0 : _appearance$areaStyle.show,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].appearance.areaStyles.show",
          value: el.props.chartItems.props[itemIndex].appearance.areaStyles.show = e.target.checked
        };
      });
    }
  }), (options == null ? void 0 : options.showSmoothOption) && /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("AppearanceSelector.appearanceSmooth.switch", "Smooth"),
    "data-testid": "AppearanceSelector.appearanceSmooth.switch",
    checked: appearance == null ? void 0 : appearance.smooth,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].appearance.smooth",
          value: el.props.chartItems.props[itemIndex].appearance.smooth = e.target.checked
        };
      });
    }
  }), (options == null ? void 0 : options.showStepOption) && /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("AppearanceSelector.appearanceStep.switch", "Step"),
    "data-testid": "AppearanceSelector.appearanceStep.switch",
    checked: appearance == null ? void 0 : appearance.step,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].appearance.step",
          value: el.props.chartItems.props[itemIndex].appearance.step = e.target.checked
        };
      });
    }
  }), (options == null ? void 0 : options.showBackgroundOption) && /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("AppearanceSelector.appearanceShowBackground.switch", "Show background"),
    "data-testid": "AppearanceSelector.appearanceShowBackground.switch",
    checked: (_chartItem$appearance = chartItem.appearance) == null ? void 0 : _chartItem$appearance.showBackground,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].appearance.showBackground",
          value: el.props.chartItems.props[itemIndex].appearance.showBackground = e.target.checked
        };
      });
    }
  }), (options == null ? void 0 : options.showStackDataOption) && /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("AppearanceSelector.appearanceStackData.switch", "Stack data"),
    "data-testid": "AppearanceSelector.appearanceStackData.switch",
    checked: (_chartItem$appearance2 = chartItem.appearance) == null ? void 0 : _chartItem$appearance2.stackData,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].appearance.stackData",
          value: el.props.chartItems.props[itemIndex].appearance.stackData = e.target.checked
        };
      });
    }
  }), (options == null ? void 0 : options.showAxisOptions) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("AppearanceSelector.appearanceHideXAxis.switch", "Hide X axis"),
    "data-testid": "AppearanceSelector.appearanceHideXAxis.switch",
    checked: appearance == null ? void 0 : appearance.hideXAxis,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].appearance.hideXAxis",
          value: el.props.chartItems.props[itemIndex].appearance.hideXAxis = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("AppearanceSelector.appearanceHideYAxis.switch", "Hide Y axis"),
    "data-testid": "AppearanceSelector.appearanceHideYAxis.switch",
    checked: appearance == null ? void 0 : appearance.hideYAxis,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].appearance.hideXAxis",
          value: el.props.chartItems.props[itemIndex].appearance.hideYAxis = e.target.checked
        };
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("AppearanceSelector.appearanceShowGrid.label", "Show grid"),
    "data-testid": "AppearanceSelector.appearanceShowGrid.switch",
    checked: appearance == null ? void 0 : appearance.showGrid,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].appearance.showGrid",
          value: el.props.chartItems.props[itemIndex].appearance.showGrid = e.target.checked
        };
      });
    }
  }));
};